import { render, staticRenderFns } from "./ProviderProductsShow.vue?vue&type=template&id=7a25f1c6&scoped=true&lang=pug&"
import script from "./ProviderProductsShow.vue?vue&type=script&lang=js&"
export * from "./ProviderProductsShow.vue?vue&type=script&lang=js&"
import style0 from "./ProviderProductsShow.vue?vue&type=style&index=0&id=7a25f1c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a25f1c6",
  null
  
)

component.options.__file = "ProviderProductsShow.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBreadcrumbs } from 'vuetify/lib'
import { VBreadcrumbsItem } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VProgressCircular } from 'vuetify/lib'
installComponents(component, {
  VBreadcrumbs,
  VBreadcrumbsItem,
  VFlex,
  VLayout,
  VProgressCircular,
})
